<mat-form-field>
  <input (change)="onChange($event)" [(ngModel)]="convertedValue" [placeholder]="translationPrefix + '.' + key |translate" matInput/>
</mat-form-field>
